export const TWITFRAME_ORIGIN = 'https://twitframe.reperio.news';

export function isMeasurableService(service) {
	return service === 'twitter' || service === 'x' || service === 'instagram';
}

// Extracts an embed height from a window message, or returns null.
// Two contracts:
// - twitframe replies {element, height} to our {element, query: "height"}
//   query — matched by the id we sent (see the twitframe page source);
// - instagram /embed iframes post MEASURE messages ({type: "MEASURE",
//   details: {height}}, sometimes JSON-encoded as a string) unprompted —
//   matched by e.source since they carry no id.
export function embedHeightFromMessage(e, iframe, twitframeId) {
	if (e.origin === TWITFRAME_ORIGIN) {
		if (
			e.data?.element === twitframeId &&
			typeof e.data.height === 'number' &&
			e.data.height > 0
		) {
			return Math.round(e.data.height);
		}
		return null;
	}

	if (
		(e.origin === 'https://www.instagram.com' || e.origin === 'https://instagram.com') &&
		iframe &&
		e.source === iframe.contentWindow
	) {
		let payload = e.data;
		if (typeof payload === 'string') {
			try {
				payload = JSON.parse(payload);
			} catch (_e) {
				return null;
			}
		}

		if (
			payload?.type === 'MEASURE' &&
			typeof payload?.details?.height === 'number' &&
			payload.details.height > 0
		) {
			return Math.round(payload.details.height);
		}
	}

	return null;
}
